export default __webpack_public_path__ + "static/media/K.e4bfc148.svg";